import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34803edc")

_pushScopeId("data-v-34803edc")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "libraries" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "libraries__subtitle body-2" }, " Explore our comprehensive session libraries ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "libraries__title" }, " Access detailed information and resources from our events ", -1)
const _hoisted_5 = { class: "libraries__parent" }
const _hoisted_6 = { class: "library-card__content" }
const _hoisted_7 = { class: "library-card__info" }
const _hoisted_8 = { class: "library-card__description" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.libraries, (library, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "library-card"
          }, [
            _createVNode("div", {
              class: "library-card__background",
              style: { background: library.backgroundColor }
            }, null, 4),
            _createVNode("div", _hoisted_6, [
              _createVNode("img", {
                class: "library-card__icon",
                src: library.brandImage,
                alt: library.title
              }, null, 8, ["src", "alt"]),
              _createVNode("div", _hoisted_7, [
                _createVNode("p", _hoisted_8, _toDisplayString(library.description), 1),
                _createVNode("a", {
                  href: library.link,
                  class: "library-card__link"
                }, "View Library", 8, ["href"])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
})